/**
 * Lazy migration: old single-goal shape → goals map.
 * Runs on read; actual write happens on next user action.
 */
export function migrateSavings(savings) {
  if (!savings) return { goals: {} };

  // Already new shape
  if (savings.goals !== undefined) return savings;

  // Legacy shape: { target, saved, monthlyTarget }
  const legacyGoal = {
    id: 'home-deposit',
    name: 'Home Deposit',
    icon: '🏠',
    color: '#3b82f6',
    target: Number(savings.target) || 0,
    saved: Number(savings.saved) || 0,
    monthlyTarget: Number(savings.monthlyTarget) || 0,
    targetDate: null,
    createdAt: new Date().toISOString(),
    priority: 0,
  };

  return { goals: { 'home-deposit': legacyGoal } };
}

/** Derive computed fields for a single goal. */
export function deriveGoal(goal) {
  const target = Number(goal.target) || 0;
  const saved = Number(goal.saved) || 0;
  const monthlyTarget = Number(goal.monthlyTarget) || 0;

  const remaining = Math.max(0, target - saved);
  const progress = target > 0 ? Math.min(100, (saved / target) * 100) : 0;

  let monthsToGoal = 0;
  if (goal.targetDate) {
    const now = new Date();
    const end = new Date(goal.targetDate);
    monthsToGoal = Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24 * 30.44)));
    // Derive implied monthly if not set
    if (!monthlyTarget && monthsToGoal > 0) {
      goal = { ...goal, monthlyTarget: Math.ceil(remaining / monthsToGoal) };
    }
  } else {
    monthsToGoal = monthlyTarget > 0 ? Math.ceil(remaining / monthlyTarget) : 0;
  }

  return { ...goal, remaining, progress, monthsToGoal };
}
